import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import ReactGA from 'react-ga4';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { Menu } from './components/Menu/Menu';
import { getCurrentLanguage } from './shared/providers/languageProvider';
import { transaltionResources } from './locales/resources';
import { getCookieConsent } from './shared/providers/cookieConsentProvider';
import { CookieSetting } from './types/cookieSetting';
import './App.css';

i18n.use(initReactI18next).init({
    resources: transaltionResources,
    lng: getCurrentLanguage().id,
    fallbackLng: 'sk',
    interpolation: {
        escapeValue: false
    }
});

const areAnalyticsEnabled = getCookieConsent() === CookieSetting.Allowed;

if (areAnalyticsEnabled) {
    const TRACKING_ID = 'G-T1YRFV5VKX';
    ReactGA.initialize(TRACKING_ID);
}

const App = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Menu />} />
            </Routes>
        </BrowserRouter>
    );
};

export default App;
